import { Injectable, NgZone } from '@angular/core';
import { 
    Firestore, 
    doc,
    docData,
    getDoc,
    onSnapshot,
    setDoc,
    updateDoc
} from '@angular/fire/firestore';
import { PathApi } from '../../paths/path-api';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';  // todo: update plugin splash-screen
import { NavController, MenuController, AlertController } from '@ionic/angular';
import { firstValueFrom, Observable, of } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Functions, HttpsCallableResult, httpsCallable } from '@angular/fire/functions';
import { Auth, authState, fetchSignInMethodsForEmail, idToken, sendPasswordResetEmail, signInWithEmailAndPassword, signOut } from '@angular/fire/auth';
import { LogoutService } from 'src/app/shared/services/logout/logout.service';
import { UserDataService } from 'src/app/shared/services/user-data/user-data.service';
import { FirebaseError } from 'firebase/app';
import { Device } from '@capacitor/device';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    unsubscribeDeviceListener: (() => void) | null = null;
    public userToken: string = null;
    public headers;
    public requestOptions;
    public tokenId: string = null;
    constructor(
        private translateService: TranslateService,
        private alertController: AlertController,
        public http: HttpClient,
        private auth: Auth,
        private firestore: Firestore,
        // private splashScreen: SplashScreen,  // todo: update plugin splash-screen
        private navCtrl: NavController,
        private menuCtrl: MenuController,
        private functions: Functions,
        private Slogout: LogoutService,
        private userData: UserDataService
    ) {
        this.headers = new HttpHeaders();
        this.headers.append("Accept", 'application/json');
        this.headers.append("Content-Type", 'application/json');
        this.requestOptions = { headers: this.headers };
    }

    // Verify if e-mail exists in Firestore Database
    verifyEmailDb(email: string, onResolve) {
        const safeResolve = (payload: any) => {
            if (typeof onResolve === 'function') {
                onResolve(payload);
            }
        };

        const call = httpsCallable(this.functions, 'dbUserGetUserByEmail');
        call({ email: email })
            .then((resp: HttpsCallableResult<any>) => { 
                const payload = resp?.data;
                const uid = payload?.result?.uid;
                if (uid) this.userData.userId = uid;
                onResolve(payload);
            })
            .catch((error) => { 
                console.error(error); 
                onResolve({ code: 404, message: 'error', result: null });
            })
    }

    // Verify if e-mail exists in Firebase Authentication
    verifyEmailAuth(email: string) {
        return new Promise((resolve, reject) => {
            // call http to verify if e-mail already exists
            this.http.post(PathApi.authChangeUserType, email, this.requestOptions)
                .subscribe(_ => {
                    // case exists, return 'exists' to front manipulation
                    resolve('exists');
                }, e => {
                    // case not exists, return 'available' to front manipulation
                    reject('available');
                });
        })
    }

    /**
     * Make account in user first access and call Firebase Auth to set user type (access nivel)
     * @param email 
     * @param password 
     * @param userUid 
     * @param type 
     */
    createAccount(email: string, password: string, userUid: string, type: number) {
        const call = httpsCallable(this.functions, 'dbUserCreateUserFirstAccess');
        return new Promise((resolve, reject) => {
            call({ email: email, password: password, userId: userUid, userType: type })
                .then((data: HttpsCallableResult<any>) => {
                    resolve(data.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    createUserPublicEvent(eventId: string, name: string, email: string, password: string, language: string, onResolve) {
        // const call = httpsCallable(this.functions, 'dbUserCreatePublicEventUserFirstAccess');
        // call({ eventId: eventId, name: name, email: email, password: password, language: language })
        // const call = httpsCallable(this.functions, 'dbUserSignUp');
        this.signUpToPublicEvent({ 
            eventId: eventId, 
            name: name, 
            email: email, 
            password: password, 
            language: language 
        }).then((result: HttpsCallableResult<any>) => {
            this.login(email, password)
                .then(() => {
                    this.userData.userId = result.data.uid;
                    onResolve(result.data);
                })
                .catch(err => console.error(err));
        }).catch((error) => {
            console.log(error);
            onResolve(null);
        });
    }

    public signUpToPublicEvent(params: {
        eventId: string,
        name?: string,
        email: string,
        password?: string,
        language: string,
        providerId?: string,
        uid?: string
    }): Promise<HttpsCallableResult<any>> {
        // console.log(`dbUserSignUp`)
        const call = httpsCallable(this.functions, 'dbUserSignUp');
        return call(params);
    }

    logToUserPublicEvent(eventId: string, name: string, email: string, password: string, language: string, onResolve) {
        this.verifyEmailDb(email, (data) => {
            if(data){
                console.log('deja enregistré !!!')
            }
        })  
    }

    // makeUsers(attendee, user, eventId) {
    //     const ref1 = doc(this.firestore, `events/${eventId}/attendees/${user.uid}`);
    //     const ref2 = doc(this.firestore, `modules/${attendee.moduleId}/attendees/${user.uid}`)
    //     const ref3 = doc(this.firestore, `users/${user.uid}`)

    //     const batch = writeBatch(this.firestore)
            
    //     batch.set(ref1, attendee);
    //     batch.set(ref2, attendee);
    //     batch.set(ref3, user);

    //     return batch.commit()

    //     //     batch
    //     //         .commit()
    //     //         .then((result) => {
    //     //             resolve(true);
    //     //         })
    //     //         .catch((e) => {
    //     //             resolve(false);
    //     //         });
    //     // });
    // }

    // checkAttendeeInAttendees(eventId: string, uid: string, onResolve) {
    //     let db = this.aFirestore.firestore;
    //     let ref = db.collection('events').doc(eventId).collection('attendees').doc(uid);

    //     ref
    //         .get()
    //         .then((snapshot) => {
    //             if (snapshot.exists) {
    //                 onResolve(true);
    //             } else {
    //                 onResolve(false);
    //             }
    //         });
    // }

    /**
     * Authenticates a user using their email and password via Firebase Authentication.
     *
     * On successful login, stores the user's UID and ID token in local storage,
     * updates the user's device ID, and returns the authentication result.
     * If authentication fails, returns the FirebaseError if applicable, or logs the error.
     *
     * @param email - The user's email address.
     * @param password - The user's password.
     * @returns A Promise that resolves to the authentication result (`UserCredential`) on success,
     *          or a `FirebaseError` on failure.
     */
    async login(email: string, password: string) {
        try {
            const res = await signInWithEmailAndPassword(this.auth, email, password);
            this.userData.userId = res.user.uid;
            localStorage.setItem('userIdentifier', res.user.uid);

            const idToken = await res.user.getIdToken(true);
            localStorage.setItem('userToken', idToken);
            this.tokenId = idToken;

            await this.updateUserDeviceId(res.user.uid);

            return res;
        } catch (err) {
            if (err instanceof FirebaseError) 
                return err;
            console.error('Login failed:', err);
        }
    }

    /**
     * Updates the device ID associated with a user in Firestore.
     *
     * This method retrieves the current device's unique identifier and checks if it matches
     * the `deviceId` stored in the user's Firestore document. If the `deviceId` is missing
     * or different, it updates the document with the current device's ID. If the user document
     * does not exist, it creates the document with the `deviceId` field.
     *
     * @param userId - The unique identifier of the user whose device ID should be updated.
     * @returns A promise that resolves when the operation is complete.
     * @throws Logs an error to the console if the update fails.
     */
    async updateUserDeviceId(userId: string) {
        try {
            const deviceInfo = await Device.getId();
            const currentDeviceId = deviceInfo.identifier;

            const userDocRef = doc(this.firestore, `users/${userId}`);
            const userSnap = await getDoc(userDocRef);

            if (userSnap) 
                if (userSnap.exists()) {
                    const data = userSnap.data() as any;
                    if (!data.deviceId || data.deviceId !== currentDeviceId) {
                        await updateDoc(userDocRef, { deviceId: currentDeviceId })
                    }   

                } else {
                    await setDoc(userDocRef, { deviceId: currentDeviceId }, { merge: true });
                }
        } catch (err) {
            console.error('Error updating user device ID:', err);
        }
    }

    /**
     * Initializes a real-time listener to validate the current device against the user's stored device ID in Firestore.
     * 
     * - Retrieves the current authenticated user and device identifier.
     * - Sets up a Firestore snapshot listener on the user's document.
     * - If the stored device ID in Firestore differs from the current device ID, triggers an alert and logs the user out.
     * - Cleans up any previous listener before setting a new one.
     * - Handles errors by logging them and logging the user out.
     * 
     * @async
     * @returns {Promise<void>} Resolves when the listener is set up or exits early if no user is authenticated.
     */
    async startDeviceValidationListener(): Promise<void> {
        const user = this.auth.currentUser;
        if (!user) return;
        
        try {
            const deviceInfo = await Device.getId();
            const currentDeviceId = deviceInfo.identifier;

            const userDocRef = doc(this.firestore, `users/${user.uid}`);
           
            if (this.unsubscribeDeviceListener) {
                this.unsubscribeDeviceListener();
            }

            this.unsubscribeDeviceListener = onSnapshot(userDocRef, (docSnap) => {
                if (docSnap.exists()) {
                    const data = docSnap.data() as any;
                    const storedDeviceId = data?.deviceId;
                    
                    if (storedDeviceId && storedDeviceId !== currentDeviceId) {
                        this.alertDeviceChange()
                            .finally(() => this.logout());
                    }
                }
            })
        } catch (err) {
            console.error('Failed to initialize device validation listener:', err);
            this.logout();
        }
    }
    
    /**
     * Stops the device validation listener if it is currently active.
     * Invokes the unsubscribe function to remove the listener and sets the reference to null.
     */
    stopDeviceValidationListener() {
        if (this.unsubscribeDeviceListener) {
            this.unsubscribeDeviceListener();
            this.unsubscribeDeviceListener = null;
        }
    }

    /**
     * Displays an alert to inform the user that their session has been closed due to a login from another device.
     * The alert includes a header, subheader, message, and an "OK" button, all of which are localized using the translation service.
     * Waits for the alert to be presented and dismissed before resolving.
     *
     * @returns {Promise<void>} A promise that resolves once the alert has been dismissed.
     */
    async alertDeviceChange(): Promise<void> {
        const alert = await this.alertController.create({
            header: this.translateService.instant('global.texts.session_closed'),
            subHeader: this.translateService.instant('global.texts.another_device_logged'),
            message: this.translateService.instant('global.texts.you_have_been_logged_out'),
            buttons: [this.translateService.instant('global.buttons.ok')],
        });

        await alert.present();
        await alert.onDidDismiss();
    }

    logout() {
        // this.splashScreen.show();  // todo: update plugin splash-screen
        // this.menuCtrl.toggle();
        this.removeStorageReferences();
        signOut(this.auth).then((_) => {
            this.navCtrl.navigateRoot(['/'])
                .then(() => {
                    window.location.reload();
                    // this.splashScreen.hide();  // todo: update plugin splash-screen
                });
        });
        this.Slogout.logout();
    }

    removeStorageReferences() {
        localStorage.removeItem("userToken");
        localStorage.removeItem("eventId");
        localStorage.removeItem("userIdentifier");
        localStorage.removeItem("homePage");
        localStorage.removeItem("timezone");
        localStorage.removeItem("eventVisible");
    }

    getIdToken() {
        return firstValueFrom(idToken(this.auth));
    }

    claimsUser(onResolve) {
        this.getIdToken()
            .then((idToken: string) => {
                // request post
                return this.http.post(
                    PathApi.authClaimsUsers,
                    { idToken: idToken },
                    this.requestOptions
                ).subscribe(
                    (claims: any) => {
                        // let aux = JSON.parse(claims['_body']);
                        onResolve(claims);
                    }
                )
            });
    }


    sendCodeNumberToEmail(user, onResolve) {
        this.http.post(
            PathApi.dbUserSendCodeNumberEmail, 
            user, 
            this.requestOptions
        ).subscribe((success) => {
            onResolve(success);
        }), err => {
            onResolve(false);
        }
    }

    sendVerificationCodeToEmail(email: string, codeNumber: string, onResolve) {
        const userLanguage = navigator.language; // example: pt-BR
        // if you do not send a specific language, the e-mail will be sent in English by default;
        this.http.post(
            PathApi.emailsSendCodeToUser, 
            { email, codeNumber, userLanguage}, 
            this.requestOptions
        ).subscribe({
            next: () => {onResolve(true)},
            error: (e) => {
                onResolve(false)
                console.error(e);
            },
        })
    }

    verifyCodeNumber(code: string, userId: string, onResolve) {
        const call = httpsCallable(this.functions, 'dbUserVerifyCodeNumber');
        call({ code: code, uid: userId }).then((data) => {
            onResolve(data.data);
        }).catch((error) => { console.log(error); });

        // let db = this.aFirestore.firestore;
        // db
        //   .collection("users")
        //   .doc(userId)
        //   .get()
        //   .then((user) => {
        //     let aux = user.data();
        //     if (aux.codeNumber == code) {
        //       onResolve({
        //         code: 200,
        //         message: 'success',
        //         result: true
        //       });
        //     } else {
        //       onResolve({
        //         code: 404,
        //         message: 'error',
        //         result: false
        //       });
        //     }
        //   })
        //   .catch((error) => {
        //     onResolve({
        //       code: 404,
        //       message: 'error',
        //       result: error
        //     });
        //   });
    }

    // removeCodeNumber(userId: string) {
    //     let db = this.aFirestore.firestore;

    //     db.collection("users").doc(userId).update({
    //         codeNumber: null
    //     });
    // }

    public authenticated(): boolean {
        let storage = localStorage.getItem('userToken');
        if (this.tokenId === undefined || this.tokenId === null && storage !== null && storage !== undefined) {
            this.tokenId = storage;
        }
        return this.tokenId !== undefined && this.tokenId !== null;
    }

    isAuthenticated(): Observable<boolean> {
        return authState(this.auth).pipe(
            takeUntil(this.Slogout.logoutSubject),
            map(u => (u) ? true : false)
        );
    }

    getUser(): Observable<any> {
        return authState(this.auth).pipe(
            takeUntil(this.Slogout.logoutSubject),
            switchMap((u) => {
                if (u) {
                    const ref = doc(this.firestore, `users/${u.uid}`);
                    return docData(ref);  
                }
                else {
                    return of(null)
                }
            })
        );
    }

    public current() {
        return firstValueFrom(authState(this.auth));
    }

    checkAuthEmail(email: string, onResolve) {
        fetchSignInMethodsForEmail(this.auth, email)
            .then(() => { onResolve(true); })
            .catch((error) => { console.error(error); onResolve(false); });
    }

    recoveryPassword(email: string, onResolve) {
        sendPasswordResetEmail(this.auth, email)
            .then(() => { onResolve(true); })
            .catch((error) => { console.error(error); onResolve(false); });
    }
}
